export interface DescansoMedico {
  idDescansoMedico: number;
  idTrabajador: number;
  idPeriodo: number;
  tipoDescanso: string;
  fechaInicio: string;
  fechaFin: string;
  diasDescanso: number;
  diasEmpleador: number;
  diasSubsidiados: number;
  numeroCITT: string | null;
  fechaEmisionCITT: string | null;
  diagnostico: string | null;
  medicoInstitucion: string | null;
  montoSubsidio: number | null;
  estado: string;
  observaciones: string | null;
  documentoSustento: string | null;
  fechaRegistro: string;
  trabajador?: {
    idTrabajador: number;
    personal?: { personaContacto?: string };
    area?: { descripcion?: string };
  };
  periodo?: {
    idPeriodo: number;
    anio: number;
    mes: number;
  };
}

export interface ResumenAnualDescanso {
  idTrabajador: number;
  nombreTrabajador: string;
  anio: number;
  totalDiasDescanso: number;
  totalDiasEmpleador: number;
  totalDiasSubsidiados: number;
  cantidadDescansos: number;
}

export const TIPOS_DESCANSO = [
  { value: 'ENFERMEDAD_COMUN', label: 'Enfermedad Comun', color: '#ed6c02' },
  { value: 'ACCIDENTE_TRABAJO', label: 'Accidente de Trabajo', color: '#d32f2f' },
  { value: 'MATERNIDAD', label: 'Maternidad', color: '#7b1fa2' },
  { value: 'ACCIDENTE_COMUN', label: 'Accidente Comun', color: '#0288d1' },
];

export const ESTADOS_DESCANSO = [
  { value: 'REGISTRADO', label: 'Registrado', color: '#757575' },
  { value: 'APROBADO', label: 'Aprobado', color: '#2e7d32' },
  { value: 'EN_SUBSIDIO', label: 'En Subsidio', color: '#0288d1' },
  { value: 'CERRADO', label: 'Cerrado', color: '#424242' },
];

export const initialDescansoMedico: Partial<DescansoMedico> = {
  idDescansoMedico: 0,
  idTrabajador: 0,
  idPeriodo: 0,
  tipoDescanso: 'ENFERMEDAD_COMUN',
  fechaInicio: '',
  fechaFin: '',
  diasDescanso: 0,
  diasEmpleador: 0,
  diasSubsidiados: 0,
  numeroCITT: null,
  fechaEmisionCITT: null,
  diagnostico: null,
  medicoInstitucion: null,
  montoSubsidio: null,
  estado: 'REGISTRADO',
  observaciones: null,
  documentoSustento: null,
};
